import { useMemo } from "react";
import { Controller, useWatch } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { ENTERPRISE_MODULE_VOLUME_VARIATION_OPTIONS } from "../../../../utils/constants";
import FieldBlock from "../../../PreActivation/components/FieldBlock";
import FieldError from "../../../PreActivation/components/FieldError";
import FieldLabel from "../../../PreActivation/components/FieldLabel";
import RadioGroup from "../../../PreActivation/components/RadioGroup";
import NumericFieldBlock from "./NumericFieldBlock";
import { PEAK_DEMAND_VALUE } from "../../enterpriseIntakeModuleUtils";
import { mapTranslatedOptions } from "./mapTranslatedOptions";

const VolumeVariationField = ({
  variationName,
  peakName,
  labelKey,
  peakLabelKey,
  control,
  errors,
  readOnly,
}) => {
  const { t } = useTranslation();
  const variationValue = useWatch({ control, name: variationName });

  const variationOptions = useMemo(
    () =>
      mapTranslatedOptions({
        options: ENTERPRISE_MODULE_VOLUME_VARIATION_OPTIONS,
        t,
      }),
    [t]
  );

  return (
    <>
      <FieldBlock>
        <FieldLabel htmlFor={variationName} text={t(labelKey)} required />
        <Controller
          name={variationName}
          control={control}
          render={({ field, fieldState }) => (
            <>
              <RadioGroup
                name={variationName}
                options={variationOptions}
                selectedValue={field.value}
                onChange={field.onChange}
                readOnly={readOnly}
              />
              <FieldError message={fieldState.error?.message} />
            </>
          )}
        />
      </FieldBlock>

      {variationValue === PEAK_DEMAND_VALUE ? (
        <NumericFieldBlock
          name={peakName}
          labelKey={peakLabelKey}
          required
          control={control}
          errors={errors}
          readOnly={readOnly}
          t={t}
        />
      ) : null}
    </>
  );
};

export default VolumeVariationField;
